import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Badge from "./General/Badge";

import {
  getName,
  getBadgeText,
  getBadgeClassByPolicyStatus,
} from "js/formatting";
import {
  getAllOwnersFromParties,
  getAllAnnuitantsFromParties,
  isAnnuityPolicyInactive,
} from "js/utilities";
import { useTranslation } from "react-i18next";

export default function AnnuityPolicyCard({ data }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const owners = getAllOwnersFromParties(data.parties);
  const loggedInOwner = owners?.find(
    (x) => x.person?.taxId === user.identityNumber
  );
  const annuitants = getAllAnnuitantsFromParties(data.parties);

  return (
    <>
      <div className="ui-grid-item">
        {data?.status && data?.status !== "" && (
          <div
            className={`ui-badge-bar ui-badge-bar-${getBadgeClassByPolicyStatus(
              data
            )}`}
          ></div>
        )}
        <div className="ui-policy-col-01">
          <div className="text-xxs text-theme-text-tertiary">
            {t("CustomerPolicies-annuity-contract")} {data.oldPolicy}
          </div>
          <div className="ui-grid-name">
            <div className="text-lg font-semibold text-theme-text-secondary">
              {t("CustomerPolicies-annuity-owner")}
              {getName(loggedInOwner?.person)}
            </div>
            {data?.status && data?.status !== "" && (
              <Badge
                status={getBadgeClassByPolicyStatus(data)}
                statusText={getBadgeText(data)}
                srPrefix={t("CustomerPolicies-policy")}
              />
            )}
          </div>
        </div>
        <hr />
        <div className="ui-grid-layout">
          <div className="ui-policy-col-03">
            {annuitants?.length > 0 && (
              <>
                <div className="text-xs text-theme-text-tertiary">
                  {t("CustomerPolicies-annuitant-name")}
                </div>
                {annuitants.map((annuitant, idx) => {
                  return (
                    <div
                      className="text-sm font-semibold text-theme-text-secondary"
                      key={`Primary - ${idx}`}
                    >
                      {getName(annuitant?.person)}
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <div className="ui-policy-col-05">
            {annuitants?.length > 0 && (
              <>
                <div className="text-xs text-theme-text-tertiary">
                  {t("CustomerPolicies-annuity-policy-type")}
                </div>
                <div className="text-sm font-semibold text-theme-text-secondary">
                  {t("CustomerPolicies-annuity")}
                </div>
              </>
            )}
          </div>
        </div>
        <Link
          className="ui-btn-arrow-details"
          aria-label={` View details for policy ${data.contractID}`}
          to={`/policies/${data.contractID}`}
        >
          <svg
            className="ui-icon w-8 h-8"
            focusable="false"
            aria-hidden="true"
            role="presentation"
          >
            <use href="#ui-icon-next"></use>
          </svg>
        </Link>
      </div>
    </>
  );
}
